import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import store from "../../../store";
//OJO no utilizar este task, utilizar PinStatusWithTimerValidationTask
//TODO borrar este archivo cuando desaparesca TV, ModalPinKeyboard 
class StatusControlPinTask extends AbstractRequestTask {
  constructor(params, version = 'v1') {
    super();
    this.ownParams = params;
    this.version = version;
  }

  getParams() {
    const params = super.getParams();
    const user = store.getState().user;
    const user_id = user.user_id || "";
    delete params.api_version;
    delete params.HKS;
    return Object.assign({}, params, { user_id, ...this.ownParams });
  }

  getUrl() {
    const protocol = 'https';
    const server = Launcher.get("akamai_mfwk");
    const endpoint = 'services/user';
    const version = this.version;
    const apiname = 'controlpin/status';

    return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
  }

}

export default StatusControlPinTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/UserControlPinStatusTask.js